// Put your applicaiton javascript here
$(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
        if ($('#agree').is(':checked')) {
            $(this).submit();
        }
        else {
            alert("You must agree with the terms and conditions of sales to check out.");
            return false;
        }
    });
});